import {
  GET_LRE_PLAN_SUCCESS,
  GET_LRE_PLAN_FAILURE,
  GET_SITE_LIST_REQUEST,
  GET_SITE_LIST_SUCCESS,
  GET_SITE_LIST_FAILURE,
  GET_LRE_ITEMS,
  GET_LRE_ITEMS_SUCCESS,
  GET_LRE_ITEMS_FAILURE,
  UPDATE_LRE_ITEMS,
  UPDATE_LRE_SUCCESS,
  UPDATE_LRE_FAILURE,
  ADD_ITEMS_TO_CART,
  ADD_ITEMS_TO_CART_SUCCESS,
  ADD_ITEMS_TO_CART_FAILURE,
  SET_PURCHASE,
  SET_PURCHASED_LIST,
  SET_TRANSACTION_STATUS,
  GET_PLAN_BY_SITES,
  GET_PLAN_BY_SITES_SUCCESS,
  GET_PLAN_BY_SITES_FAILURE,
  CREATE_SYSTEM_SUCCESS,
  CREATE_SYSTEM_REQUEST,
  CREATE_SYSTEM_FAILURE,
  GET_AGREEMENT_REQUEST,
  GET_AGREEMENT_FAILURE,
  GET_AGREEMENT_SUCCESS
} from './constants';
import { findIndex } from '../../utils/lodash';

let initialState = {
  message: null,
  LREPlans: null,
  siteData: { sites: null, total_records: 0, total_display_records: 0, page: 1, limit: 10 },
  purchase: {},
  lreItems: [],
  loading: false,
  circularLoading: false,
  messageType: '',
  errorMessage: '',
  purchasedList: {},
  sitesDetail: [],
  orderNo: '',
  orderStatus: '',
  lrePlansBySiteId: []
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_LRE_PLAN_SUCCESS:
      return { ...state, LREPlans: action.LREPlans };
    case GET_LRE_PLAN_FAILURE:
      return { ...state, LREPlans: null };
    case GET_SITE_LIST_REQUEST:
      return { ...state, loading: true, message: null };
    case GET_SITE_LIST_SUCCESS:
      return { ...state, siteData: action.siteList, message: null, loading: false };
    case GET_LRE_ITEMS:
      return { ...state, loading: true, message: null };
    case GET_LRE_ITEMS_SUCCESS:
      return { ...state, lreItems: action.lreItems, message: null, loading: false };
    case GET_LRE_ITEMS_FAILURE:
      return {
        ...state,
        message: 'Something went wrong!',
        loading: false
      };
    case UPDATE_LRE_ITEMS:
      return { ...state, circularLoading: true, messageType: '', errorMessage: null };
    case UPDATE_LRE_SUCCESS:
      return { ...state, messageType: 'success', errorMessage: null, circularLoading: false };
    case UPDATE_LRE_FAILURE:
      return {
        ...state,
        messageType: 'error',
        errorMessage: 'Something went wrong! Please try again later',
        circularLoading: false
      };
    case ADD_ITEMS_TO_CART:
      return { ...state, circularLoading: true, messageType: '', errorMessage: null };
    case ADD_ITEMS_TO_CART_SUCCESS:
      return { ...state, messageType: 'success', errorMessage: null, circularLoading: false };
    case ADD_ITEMS_TO_CART_FAILURE:
      return {
        ...state,
        messageType: 'error',
        errorMessage: 'Something went wrong! Please try again later',
        circularLoading: false
      };
    case GET_PLAN_BY_SITES:
      return { ...state, loading: true, message: null };
    case GET_PLAN_BY_SITES_SUCCESS:
      return { ...state, lrePlansBySiteId: action.lrePlansBySiteId, message: null, loading: false };
    case GET_PLAN_BY_SITES_FAILURE:
      return { ...state, message: action.message, loading: false };
    case GET_SITE_LIST_FAILURE:
      return {
        ...state,
        siteData: { ...state.siteData, sites: null },
        message: 'Something went wrong!',
        loading: false
      };
    case SET_TRANSACTION_STATUS:
      return {
        ...state,
        orderNo: action.payload.orderNo,
        orderStatus: action.payload.orderStatus
      };
    case SET_PURCHASE: {
      const { sku, siteId, value, siteDetail } = action.payload;
      const purchase = {
        ...state.purchase,
        ...(siteId && { [siteId]: sku })
      };

      if (!value) {
        delete purchase[siteId];
      }

      let sitesDetail = state.sitesDetail || [];
      const siteIndex = sitesDetail.length > 0 ? findIndex(sitesDetail, sites => sites.site_id === siteId) : -1;
      if (value) {
        siteIndex >= 0 && sitesDetail.splice(siteIndex, 1);
        sitesDetail = [ ...sitesDetail, siteDetail ];
      } else {
        siteIndex >= 0 && sitesDetail.splice(siteIndex, 1);
      }

      if (!siteId && state.siteData.sites.length) {
        state.siteData.sites.forEach(site => {
          if (value) {
            purchase[site.system_id] = sku;
          } else {
            delete purchase[site.system_id];
          }
        });
      }

      return { ...state, purchase, sitesDetail: sitesDetail || [] };
    }
    case SET_PURCHASED_LIST: {
      const { siteId, sku, planEnd, companyId, isExtendedByInstaller } = action.payload;
      const purchasedList = {
        ...state.purchasedList,
        [siteId]: {
          sku,
          planEnd,
          companyId,
          isExtendedByInstaller
        }
      };

      return { ...state, purchasedList };
    }
    case CREATE_SYSTEM_SUCCESS:
      return { ...state, loading: false, message: action.message };
    case CREATE_SYSTEM_REQUEST:
      return { ...state, loading: true };
    case CREATE_SYSTEM_FAILURE:
      return { ...state, loading: false, message: action.message };
    case GET_AGREEMENT_REQUEST:
      return {
        ...state,
        lppDownloadingAgreement: true,
        messageType: '',
        errorMessage: ''
      };
    case GET_AGREEMENT_SUCCESS:
      return {
        ...state,
        lppDownloadingAgreement: false,
        messageType: '',
        errorMessage: ''
      };
    case GET_AGREEMENT_FAILURE:
      return {
        ...state,
        lppDownloadingAgreement: false,
        messageType: 'error',
        errorMessage: action.message
      };
    default:
      return state;
  }
}

export default reducer;
